module.exports = __webpack_public_path__ + "static/media/back.7f5eb751.svg";